import { type FileLike } from '@rpldy/shared'

import { type Enum } from '@ui/utils/enums'

export const UploadFileStatuses = {
  ADDED: 'ADDED',
  PROGRESS: 'PROGRESS',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
  CANCELLED: 'CANCELLED',
  DELETING: 'DELETING',
} as const

export type UploadFileStatus = Enum<typeof UploadFileStatuses>

export interface UploadFile {
  id: string
  file?: string
  externalId?: string | number
  name?: string
  preview?: string
  mimetype?: string
  length?: number
  status: UploadFileStatus
  progress: number
  completed: boolean
  error?: string
  rawFile: File | FileLike
  rawResponse: any
}

export type UploadAnalyticsIds = {
  /**
   * Analytics ID for the file dropzone area
   */
  uploadDropzone?: string
  /**
   * Analytics ID for the upload button
   */
  uploadButton?: string
  /**
   * Analytics ID for individual file container rows
   */
  uploadFileContainer?: string
}
